/**
 * Runs after `window.themeVariables` is set (see snippets/js-variables.liquid).
 * Captcha scroll restoration and legacy Shopify page layout normalization.
 */
(function () {
  'use strict';

  var vars = window.themeVariables;
  if (!vars || !vars.settings) return;
  var pageType = vars.settings.pageType;

  if (pageType === 'captcha' && history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  if (pageType === 'policy') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelector('.shopify-policy__title')?.classList.add('h2');
      document.querySelector('.rte')?.classList.add('prose');
    });
  } else if (pageType === '') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelector('.shopify-email-marketing-confirmation__container')?.classList.add('prose');
    });
  }
})();
